/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyEmployeeRoleChangeNameRequestDto
 */
export interface CompanyEmployeeRoleChangeNameRequestDto {
  /**
   *
   * @type {string}
   * @memberof CompanyEmployeeRoleChangeNameRequestDto
   */
  name: string;
}

export function CompanyEmployeeRoleChangeNameRequestDtoFromJSON(json: any): CompanyEmployeeRoleChangeNameRequestDto {
  return CompanyEmployeeRoleChangeNameRequestDtoFromJSONTyped(json, false);
}

export function CompanyEmployeeRoleChangeNameRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyEmployeeRoleChangeNameRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function CompanyEmployeeRoleChangeNameRequestDtoToJSON(
  value?: CompanyEmployeeRoleChangeNameRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
  };
}
